import Authority from "@app/model/authentication/Authority";
import useSiteState from "@app/state/SiteState";
import SecurityHelper from "@util/SecurityHelper";
import ACLAuthority from "@app/model/profile/ACLAuthority";
import CompanyHotel from "@app/model/company_hotel/CompanyHotel";
import Domain from '@app/model/_common/Domain';

const useSecurity = () => {
	const principal = useSiteState(state => state.principal);

	const isAdmin = () => {
		return SecurityHelper.hasAnyAuthority(principal, [Authority.ADMIN]);
	};


	return {
		hasPricingAuthority: (required: ACLAuthority) => SecurityHelper.hasPricingAuthority(principal, required),
		hasAccess: (authorities: Authority[]) => SecurityHelper.hasAnyAuthority(principal, authorities),
		hasAnyAuthority: (authorities: Authority[]) => SecurityHelper.hasAnyAuthority(principal, authorities),
		hasAclAuthority: (companyHotel: CompanyHotel | undefined, aclAuthority: ACLAuthority) => SecurityHelper.hasAclAuthority(principal, companyHotel, aclAuthority),
		hasAnyAclAuthority: (aclAuthority: ACLAuthority) => SecurityHelper.hasAnyAclAuthority(principal, aclAuthority),
		isAuthenticated: () => SecurityHelper.isAuthenticated(principal),
		hasAnyCompanyHotelDomainEnabled: (domain: Domain) => SecurityHelper.hasAnyCompanyHotelDomainEnabled(principal, domain),
		hasCompanyHotelDomainAuthority: (companyHotel: CompanyHotel | undefined, domain: Domain) => SecurityHelper.hasCompanyHotelDomainAuthority(principal, companyHotel, domain),
		hasRmsAccess: (companyHotel: CompanyHotel | undefined) => SecurityHelper.hasCompanyHotelDomainAuthority(principal, companyHotel, Domain.RMS),
		hasBiToolAccess: (companyHotel: CompanyHotel | undefined) => SecurityHelper.hasCompanyHotelDomainAuthority(principal, companyHotel, Domain.BI_TOOL),
		principal: principal!,
		isAdmin: isAdmin
	}
}

export default useSecurity;
